import { useMsal, AuthenticatedTemplate } from "@azure/msal-react";
import AccessDenied from "./AccessDenied";

export default function ProtectedRoutes({ children, role }) {
  const { accounts } = useMsal();
  const activeAccount = accounts[0]; // or use getActiveAccount() if you prefer

  return (
    <AuthenticatedTemplate>
      {activeAccount?.idTokenClaims?.roles?.includes(role) ? (
        children
      ) : (
        <AccessDenied />
      )}
    </AuthenticatedTemplate>
  );
}
